import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../AiChat.testIds';
import { cancelledTextStyles } from '../../ToolConfirmationCard.styles';
import { getCancelledMessage } from '../../ToolConfirmationCard.utils';

const CancelledStatus = ({ reason }) => (
  <Typography
    data-testid={AiChatTestIds.TOOL_CONFIRMATION_CARD_CANCELLED}
    sx={cancelledTextStyles}
    variant="regular12"
  >
    {getCancelledMessage(reason)}
  </Typography>
);

CancelledStatus.propTypes = {
  reason: PropTypes.string,
};

export default CancelledStatus;
